import React from "react";
import { Link } from "react-router-dom";

const Sidebar = () => {
  return (
    <div className="section-menu-left">
      <div className="box-logo">
        <Link to="/" id="site-logo-inner">
          <img
            className=""
            id="logo_header"
            alt=""
            src="assets/images/logo/admin_logo.png"
            data-light="images/logo/logo.png"
            data-dark="images/logo/logo-dark.png"
          />
        </Link>
        <div className="button-show-hide">
          <i className="icon-menu-left"></i>
        </div>
      </div>
      <div className="section-menu-left-wrap">
        <div className="center">
          <div className="center-item">
            <div className="center-heading">Main Home</div>
            <ul className="menu-list">
              <li className="menu-item has-children active">
                <Link to="/" className="menu-item-button">
                  <div className="icon">
                    <i className="icon-grid"></i>
                  </div>
                  <div className="text">Dashboard</div>
                </Link>
              </li>
            </ul>
          </div>
          <div className="center-item">
            <div className="center-heading">All page</div>
            <ul className="menu-list">
              <li className="menu-item has-children">
                <Link to="/category" className="menu-item-button">
                  <div className="icon">
                    <i className="icon-image"></i>
                  </div>
                  <div className="text">category</div>
                </Link>
              </li>
              <li className="menu-item has-children">
                <Link to="/product" className="menu-item-button">
                  <div className="icon">
                    <i className="icon-layers"></i>
                  </div>
                  <div className="text">Product Categories</div>
                </Link>
              </li>
              <li className="menu-item has-children">
                <Link to="/product-images" className="menu-item-button">
                  <div className="icon">
                    <i className="icon-image"></i>
                  </div>
                  <div className="text">Product</div>
                </Link>
              </li>
              <li className="menu-item has-children">
                <Link to="/sliders" className="menu-item-button">
                  <div className="icon">
                    <i className="icon-book"></i>
                  </div>
                  <div className="text">Sliders</div>
                </Link>
              </li>
              <li className="menu-item has-children">
                <Link to="/inquiry" className="menu-item-button">
                  <div className="icon">
                    <i className="icon-info"></i>
                  </div>
                  <div className="text">Inquiry</div>
                </Link>
              </li>
              <li className="menu-item has-children">
                <Link to="/about-detail" className="menu-item-button">
                  <div className="icon">
                    <i className="icon-file"></i>
                  </div>
                  <div className="text">About us</div>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
